import React from "react";
import { NavLink } from "react-router-dom";
import "./index.scss";
import {
  orders,
  ordersDetails,
  profile,
  renewal,
} from "../../utils/router/constant";
import {
  LogoutIcon,
  OrderIcon,
  PorfileIcon,
  RenewalIcon,
} from "../../assets/images/svg/svg";
import { useSelector } from "react-redux";

const TabWidget = ({ handleLogoutClick = "", show = false }) => {
  const customerData = useSelector((state) => state.common.customerData);
  const isActiveTab = (tab) => {
    if (show) {
      return tab === "logout";
    }
    return window.location.pathname === tab;
  };

  return (
    <div className="tabs-container">
      {customerData.is_first_login === 0 ?
        <>
          <NavLink
            to={orders}
            className={`tab ${isActiveTab(orders) ? "active" : ""}`}
          >
            <span className="icon profile-icon">
            <OrderIcon isActive={isActiveTab(orders) || isActiveTab(ordersDetails)} />
            </span>
            Orders
          </NavLink>
          <NavLink
            to={renewal}
            className={`tab ${isActiveTab(renewal) ? "active" : ""}`}
          >
            <span className="icon profile-icon">
              <RenewalIcon isActive={isActiveTab(renewal)} />
            </span>
            Renewal
          </NavLink>
        </>
        : ""
      }
      <NavLink
        to={profile}
        className={`tab ${isActiveTab(profile) ? "active" : ""}`}
      >
        <span className="icon profile-icon">
          <PorfileIcon isActive={isActiveTab(profile)} />
        </span>
        Profile
      </NavLink>
      <div
        className={`tab tab-logout ${isActiveTab("logout") ? "active" : ""}`}
        onClick={handleLogoutClick}
      >
        <span className="icon profile-icon">
          <LogoutIcon />
        </span>
        Logout
      </div>
    </div>
  );
};

export default TabWidget;
